/** @jsx jsx */
import PropTypes from 'prop-types'
import { Button, jsx } from 'theme-ui'
import CloseIcon from '~/assets/images/icons/close.inline.svg'
import HamburgerIcon from '~/assets/images/icons/hamburger.inline.svg'

const NavMenuToggle = ({ children, onClick, isOpen }) => {
  return (
    <Button
      key="menu"
      variant="reset"
      onClick={onClick}
      sx={{
        alignItems: 'center',
        cursor: 'pointer',
        display: ['flex', null, 'none'],
        height: '100%',
        ml: -2,
        p: 2,
        width: '75px',
      }}
    >
      {isOpen && (
        <CloseIcon
          sx={{
            height: 'auto',
            width: '22px',
          }}
        />
      )}
      {!isOpen && (
        <HamburgerIcon
          sx={{
            height: 'auto',
            width: '22px',
          }}
        />
      )}
    </Button>
  )
}

NavMenuToggle.propTypes = {
  onClick: PropTypes.func,
}

export default NavMenuToggle
